import { useRouter } from 'next/router';
import { parse } from 'query-string';
import { useEffect } from 'react';

import { SearchOrganizationsParams } from '~/api/v2/searches/organizations/get';

export function getParamsFromQuery(searchParams: URLSearchParams): SearchOrganizationsParams {
  if (searchParams.toString() === '') {
    return {};
  }
  const keywordQ = searchParams.get('keyword');
  const locationsQ = searchParams.get('locations');
  const socialIssuesQ = searchParams.get('social_issues');
  const sdgsQ = searchParams.get('sdgs');

  /** `string | string[]`を`string[]`に統一する */
  const toArray = (it: string | string[] | null) => {
    if (it == null) return [];
    return [it].flat();
  };
  return {
    keyword: typeof keywordQ === 'string' ? keywordQ : '',
    locations: toArray(locationsQ),
    social_issues: toArray(socialIssuesQ),
    sdgs: toArray(sdgsQ).map(Number),
  };
}

/** ブラウザの戻る/進むをした場合 callbackを実行する */
export function useOnPopState(fn: () => void) {
  const router = useRouter();
  useEffect(() => {
    router.beforePopState(() => {
      // NOTE: beforePopStateは遷移する前に実行されるため、setTimeoutしないと`location.search`が更新されない
      setTimeout(fn, 0);
      return true;
    });
    return () => router.beforePopState(() => true);
  }, []);
}
